import MyCalculationsAgentManager from "../views/MyCalculationsAgentManager";


const menu = [
  {title: "Реестр расчетов", icon: "file_copy", url:"/calculations", id: 4},
]

const routes = [
    {
      path: "/calculations",
      component: MyCalculationsAgentManager,
      meta: {
        forAuth: true
      }
    },
  ]

  export default {menu,routes}
